import { defineComponent as _defineComponent } from 'vue'
import { AnalyticsPromoAttrs } from 'JS/utilities/analytics';
import { TileGridWidgetBannerTile } from 'JS/dxp/types/widgets/tile-grid-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'TileGridWidgetBannerTile',
  props: {
    tile: null,
    promoAttrs: null
  },
  setup(__props: any) {

const props = __props as {
	tile: TileGridWidgetBannerTile;
	promoAttrs: AnalyticsPromoAttrs;
}




return { __sfc: true,props }
}

})